/**
 * Constants for `main`.
 *
 * @module @app/constants
 */

/**
 * Load base translations, resilient to a transient network/chunk failure at boot. A few
 * quick attempts run BEFORE first paint (so a blip recovers invisibly); if those exhaust,
 * we render anyway (t() falls back to keys) and keep retrying in the background — a later
 * success dispatches `i18n:namespaceLoaded`, which re-renders components with real strings.
 */
export const PRE_RENDER_DELAYS_MS = [0, 400, 900];
